import axios from "axios";
import router from "@/router";

const getDefaultState = () => {
  return {
  kill_list: [],
  kill_list_statuses:[],
  kill_list_loading: false
  };
};

const state = getDefaultState();

const getters = {
  getKillList: state => {
    return state.kill_list;
  },
  getKillListStatuses: state => {
    return state.kill_list_statuses;
  },
  getKillListLoading: state => {
    return state.kill_list_loading;
  }
};

const actions = {
  fetchKillList({ commit, rootGetters }, payload) {
    commit("setKillListLoading", true);
    
    const data = {
      query: `
        query {
          allKillList (
            limit: ${payload.limit},
            offset: ${payload.offset != null ? payload.offset : null},
          ) {
            id
            reference
            status
            process_type
            created_at
            updated_at
          }
          killListStatuses
        }
      `
    };
    console.log("GraphQL query:", data.query);

    axios.post(rootGetters.getGraphQlUrl, data, rootGetters.getDefConf)
      .then(res => {
        if (res.data.errors !== undefined && res.data.errors.length > 0) {
          alert(res.data.errors[0].message);
          console.log(res);
        } else {
          
          commit(
            "setKillList",
            res.data.data.allKillList.map(kl => {
              return {
                id: kl.id,
                reference: kl.reference,
                status: kl.status,
                process_type: kl.process_type,
                created_at: kl.created_at,
                updated_at: kl.updated_at
              };
            })
          );
          commit("setKillListStatuses", res.data.data.killListStatuses);
        }
      })
      .catch(err => {
        alert(err);
        console.error(err);
      })
      .finally(() => {
        commit("setKillListLoading", false);
      });
  },
  updateStatus({ commit, rootGetters }, payload) {
    const data = {
      query: `
        mutation {
          KillListUpdateStatus (
            id: ${payload.id},
            status: "${payload.status}"
          ) {
            id
            reference
            status
            process_type
            created_at
            updated_at
          }
        }
      `
    };
    console.log("GraphQL query:", data.query);
    
    axios.post(rootGetters.getGraphQlUrl, data, rootGetters.getDefConf)
      .then(res => {
        if (res.data.errors !== undefined && res.data.errors.length > 0) {
          alert(res.data.errors[0].message);
          console.log(res);
        } else {
          commit("updateListElement", { id: payload.id, value: res.data.data.KillListUpdateStatus });
         
        }
      })
      .catch(err => {
        alert(err);
        console.error(err);
      });
  },
  
};

const mutations = {
  setKillList(state, value) {
    state.kill_list = value;
  },
  setKillListStatuses(state, value) {
    state.kill_list_statuses = value;
  },
  setKillListLoading(state, value) {
    state.kill_list_loading = value;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
  updateListElement(state, { id, value }) {
    const index = state.kill_list.findIndex(item => item.id === id);
    if (index !== -1) {
      state.kill_list[index] = { ...state.kill_list[index], ...value };
    } else {
      console.warn(`Element with id ${id} not found in kill_list.`);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};